<template>
    <Transition>
        <div style="margin-right: 10px;" v-if="candidate">
        <div class="form container px-2">
        <h5><b>L. Comments by Dean/Director/Librarian (include confirmation whether adverse comments on staff, if any have
                been communicated to the staff concerned): </b></h5>

        <div class="d-flex flex-wrap mb-3">
            <span class="flex-fill p-0">
                <textarea v-model="deanComments" rows="5" type="text" class="form-control pb-0" disabled></textarea>
            </span>
        </div>
        <div class="text-start my-5">
            <div v-if="!deanApproval && deanCommentDate" class="mb-4">
                <h6><b>Your Dean doesn't approve you to make final submission.</b></h6>
                <small>You are expected to make corrections and resubmit to the Dean.</small>
            </div>
            <div v-if="deanApproval" class="mb-4">
                <h6><b>Your Dean approves you to make final submission.</b></h6>
                <small>You can click the Submit for Assessment button below.</small>
            </div>
        </div>
        <div v-if="deanCommentDate" class="d-flex flex-wrap mx-4">
            <span class="pe-0 me-2">
                <p class="mb-0"><b>
                        Dean's comment date:
                    </b></p>
            </span>
            <span class="p-0">
                <p>{{ deanCommentDate }}</p>
            </span>
        </div>
        <div v-if="submitToDeanDate" class="d-flex flex-wrap mx-4">
            <span class="pe-0 me-2">
                <p class="mb-0"><b>
                    Submission to Dean date (Most recent):
                    </b></p>
            </span>
            <span class="p-0">
                <p>{{ submitToDeanDate }}</p>
            </span>
        </div>
        <div v-if="deanEmail" class="d-flex flex-wrap mx-4">
            <span class="pe-0 me-2">
                <p class="mb-0"><b>
                        Dean's email:
                    </b></p>
            </span>
            <span class="p-0">
                <p>{{ deanEmail }}</p>
            </span>
        </div>
        <div class="d-flex flex-row-reverse my-5">
            
            <button v-if="!candidate.submitted && deanApproval" type="button" class="btn btn-success" data-bs-toggle="modal" data-bs-target="#staticBackdrop">Submit for Assessment</button>
            <button v-if="!deanApproval && deanCommentDate" type="button" class="btn btn-success" data-bs-toggle="modal" data-bs-target="#staticBackdrop1">Resubmit to Dean</button>
            <router-link class="me-3" to="/sectionj&k">
                <button type="button" class="btn btn-success">Previous Section</button>
            </router-link>
        </div>

        <!--Resubmit to Dean modal-->
        <div class="modal fade" id="staticBackdrop1" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Resubmit to Dean</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="container mb-4">
                            <span class="flex-fill p-0">
                                <input type="text" class="form-control pb-0" name="newDeanEmail" v-model="newDeanEmail" placeholder="Dean Email">
                            </span>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="resubmitToDean()" type="button" class="btn btn-success" data-bs-dismiss="modal">Resubmit</button>
                    </div>
                </div>
            </div>
        </div>

        <!--Final Submit modal-->
        <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title"><b>Final Submission</b></h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="container px-3">
                            <h6 class="lh-base justify">You are about to submit your appraisal documents for assessment by the appraisal panel. If you click submit below, new changes to your document will not be considered for assessment, until after the appraisal exercise. </h6>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div class="px-3">
                            <button @click="finalSubmit()" type="button" class="btn btn-success" data-bs-dismiss="modal">Yes, Submit</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
</Transition></template>
<script>
import DataService from '../../services/dataservice';

export default {
    name: 'sectionL',
    emits: ['toggleLoader', 'setSection', 'submitted'],
    data() {
        return { candidate: '',
            deanComments: '',
            deanEmail: '',
            newDeanEmail: '',
            deanCommentDate: '',
            deanApproval: false,
            finalSubmitDate: '',
            submitToDeanDate: '',
            candidateId: ''
        }
    },
    created() {
        this.$emit('setSection', 'Section L');
        this.setData()
    },
    methods: {
        async resubmitToDean(){
            this.$emit('toggleLoader');

            const date = new Date();

            if(this.newDeanEmail) {
                var regex = /^[\w\-\.\+]+\@[a-zA-Z0-9\. \-]+\.[a-zA-z0-9]{2,4}$/;
                if (this.newDeanEmail.match(regex) == null){
                    alert ('Enter a correct email');
                    this.$emit('toggleLoader');
                    return
                }

                var dataDetails = {
                    deanEmail: this.newDeanEmail.trim().toLowerCase(),
                    submitToDeanDate: date.getUTCDate() + '/' + (Number(date.getUTCMonth()) + 1) + '/' + date.getUTCFullYear() 
                }

                const res = await DataService.saveData(dataDetails);

                if (res) {
                    alert('Successfully resubmitted to Dean');
                    this.deanEmail = dataDetails.deanEmail;
                }
            } else {
                alert("Enter your Dean's email")
            }
            this.$emit('toggleLoader');
        },
        async finalSubmit(){
            this.$emit('toggleLoader');

            const date = new Date();

            var dataDetails = {
                finalSubmitDate: date.getUTCDate() + '/' + (Number(date.getUTCMonth()) + 1) + '/' + date.getUTCFullYear(),
                submitted: true,
            }

            const candidate = await DataService.saveData(dataDetails);

            if (candidate) {
                alert('You have successfully submitted your documents for appraisal');
                /*
                this.candidate = candidate;
                this.candidateId = candidate._id
                this.deanComments = candidate.deanComments ? candidate.deanComments.comment : '';
                this.deanEmail = candidate.deanEmail ? candidate.deanEmail : '';
                this.deanApproval = candidate.deanComments ? candidate.deanComments.approval : false;
                this.deanCommentDate = candidate.deanComments ? candidate.deanComments.date : '';
                this.submitToDeanDate = candidate.submitToDeanDate ? candidate.submitToDeanDate : '';
                this.finalSubmitDate = candidate.finalSubmitDate ? candidate.finalSubmitDate : '';
                */
                this.$emit('toggleLoader');
                this.$router.push({ path: `/sectiona` });
                return
            }
            this.$emit('toggleLoader');
        },
        async setData() {
            this.$emit('toggleLoader');
            
            window.scrollTo({ top: 0, behavior: 'smooth' });

            const date = new Date();

            const candidate = await DataService.getCandidate(JSON.parse(window.localStorage['user'])._id);

            if (candidate) { 
                if ((candidate.staffType == "Junior Non-academic") || (candidate.staffType == "Senior Non-academic")) {
                    this.$emit('toggleLoader');
                    this.$router.push({ path: `/section1` });
                    return
                }
                this.$emit('submitted', candidate.submitted);
                this.candidate = candidate;
                this.candidateId = candidate._id
                this.deanComments = candidate.deanComments ? candidate.deanComments.comment : '';
                this.deanEmail = candidate.deanEmail ? candidate.deanEmail : '';
                this.deanApproval = candidate.deanComments ? candidate.deanComments.approval : false;
                this.deanCommentDate = candidate.deanComments ? candidate.deanComments.date : '';
                this.submitToDeanDate = candidate.submitToDeanDate ? candidate.submitToDeanDate : '';
                this.finalSubmitDate = candidate.finalSubmitDate ? candidate.finalSubmitDate : '';
            }

            this.$emit('toggleLoader')
        }
    }
}
</script>
